import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './action-bar.sass'

@Component
export class ActionBar extends Vue {

  render (h: CreateElement) {
    return (
      <div class='component-action-bar'>
        {this.$slots.default}
      </div>
    )
  }

}
